import axios from "axios";
import qs from "qs";
import { sort_ASCII } from "./util";
import md5 from "js-md5";
import { Toast } from "vant";
import {addTokenConfig, jumpToWeChatLogin} from "./wxLoginFun";
const host = window.location.host,
  protocol = window.location.protocol;
let getBaseUrl = "";

if (
  process.env.VUE_APP_ENV == "test" ||
  process.env.VUE_APP_ENV == "development"
) {
  // 测试或开发环境
    getBaseUrl = "https://agent-api-test.classba.cn/agentmanageapplet/api/";
    // getBaseUrl = `http://oe.zc.dev.myyixue.com/agentapplet/api/`;
  // getBaseUrl = `https://agent-applet-pre.songshuai.com/api/`;
} else if (process.env.VUE_APP_ENV == "pre") {
  getBaseUrl = `https://agent-api-pre.classba.cn/agentmanageapplet/api/`;
} else if (process.env.VUE_APP_ENV == "devserver") {
  getBaseUrl = `http://wangruimeng.zc.dev.myyixue.com/agentapplet/api/`;
} else if (host.indexOf('exp4pad-pre.classba.cn') > -1) { // 开发环境
  getBaseUrl = 'https://agent-api-pre.classba.cn/agentmanageapplet/api/';
} else if (host.indexOf('exp4pad.classba.cn') > -1) { // 正式环境
  getBaseUrl = 'https://agent-api.classba.cn/agentmanageapplet/api/';
} else {
  getBaseUrl = `https://agent-api-test.classba.cn/agentmanageapplet/api/`;
  // getBaseUrl = `http://oe.zc.dev.myyixue.com/agentapplet/api/`;
}
//开发环境配置
if (process.env.VUE_APP_ENV == "development") {
  // 测试或开发环境
  // getBaseUrl = "/agentapplet/api/";
  // getBaseUrl = "http://chenxin.zc.dev.myyixue.com/agentapplet/api/";
  // getBaseUrl = `https://agent-applet-pre.songshuai.com/api/`;
}
axios.defaults.withCredentials = false;
const service = axios.create({
  baseURL: getBaseUrl,
  withCredentials: false,
  timeout: 10 * 1000, // request timeout
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});
service.interceptors.request.use(
  function (config) {
    if (config.useDataForm) {
      delete config.useDataForm;
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      if (
        config.params &&
        config.params instanceof Object &&
        !config.params.sign
      ) {
        config.params["sign"] = md5(
          decodeURIComponent(sort_ASCII(config.params) + "yx_2020_express_dl")
        );
      }
      const params = config.data ? JSON.parse(config.data) : {};
      if (params && !params.sign) {
        const params = JSON.parse(config.data);
        config.data = JSON.stringify({
          ...params,
          sign: md5(
            decodeURIComponent(sort_ASCII(params) + "yx_2020_express_dl")
          ),
        });
      }
    }
    return Promise.resolve(addTokenConfig(config));
  },
  function (error) {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  function (response) {
    if(jumpToWeChatLogin(response)) {
      let retData;
      if (response.data.code < 0) {
        retData = {
          ...response.data,
          message: "系统开小差了，刷新后再试",
        };
      } else {
        retData = {
          ...response.data,
        };
      }
      return Promise.resolve(retData);
    }
  },
  function (error) {
    Toast("系统开小差了，刷新后再试");
    return Promise.reject(error);
  }
);

class AccountAxios {
  constructor(options = {}) {
    this.options = options;
  }
  request(options) {
    return service.request(options);
  }
  get(url, options = {}) {
    return this.request({
      url: url,
      params: {
        ...options,
      },
    });
  }
  post(url, data, options = {}) {
    if (data instanceof Object) {
      data = JSON.stringify(data);
    }
    return this.request({
      method: "post",
      url,
      data,
      ...options,
    });
  }
  uploadPost(url, data, options = {}) {
    // if (data instanceof Object) {
    //     data = JSON.stringify(data);
    // }
    return this.request({
      method: "post",
      url,
      data,
      useDataForm: true,
      ...options,
    });
  }
}
const instanceAxios = new AccountAxios();
export const request = instanceAxios.request.bind(instanceAxios);
export const get = instanceAxios.get.bind(instanceAxios);
export const post = instanceAxios.post.bind(instanceAxios);
export const uploadPost = instanceAxios.uploadPost.bind(instanceAxios);
